import { Stack, Typography } from "@mui/material";
import {
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { GridDefinition } from "./NzcDataGrid.type";

interface NzcCustomFilterToolbarProps {
  gridDefinition: GridDefinition;
}

function NzcCustomFilterToolbar({
  gridDefinition,
}: Readonly<NzcCustomFilterToolbarProps>) {
  return (
    <GridToolbarContainer>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={2}>
          {gridDefinition.toolbarTitle && (
            <Typography
              variant="h5"
              sx={{
                justifyContent: "center",
                fontWeight: "400",
                color: "primary.main",
                ml: 2,
                mr: 2,
              }}
            >
              {gridDefinition.toolbarTitle}
            </Typography>
          )}

          {!gridDefinition.onlyExport && <GridToolbarFilterButton />}

          {!gridDefinition.onlyExport && <GridToolbarDensitySelector />}

          {gridDefinition.export && (
            <GridToolbarExport
              csvOptions={{
                fileName: gridDefinition.exportFileName ?? "filename.csv",
              }}
              printOptions={{ disableToolbarButton: true }}
            />
          )}

          {gridDefinition.quickFilter && (
            <GridToolbarQuickFilter
              sx={{
                "&:hover": {
                  fontWeight: "800",
                },
                fontSize: "18px",
              }}
            />
          )}
        </Stack>
      </Stack>
    </GridToolbarContainer>
  );
}

export default NzcCustomFilterToolbar;